import React from 'react';
import { addApolloState, getApollo } from '@lib/apollo/apolloClient';
import GET_STYLE_QUIZ_QUESTION from '@graphql/StyleQuiz/queries/get-style-quiz-question.graphql';
import StyleQuizRoomSelection from '@components/pages/StyleQuiz/StyleQuizRoomSelection/StyleQuizRoomSelection';
import Compose from '@components/shared/Compose';
import QuizStorageProvider from '@components/pages/StyleQuiz/shared/context/QuizStorageProvider';
import QUESTION_IDS from '@components/shared/questions/utils/questionIds';
import { withAuthenticatedUser } from '@lib/user/auth';

const roomSelection = (props: any) => {
  return (
    <Compose
      components={[
        QuizStorageProvider
      ]}
    >
      <StyleQuizRoomSelection {...props} />
    </Compose>
  );
};

export default roomSelection;

export const getServerSideProps = withAuthenticatedUser(async ({
  user,
  experimentVariations,
}) => {
  const apolloClient = getApollo();
  const response = await apolloClient.query({
    query: GET_STYLE_QUIZ_QUESTION,
    variables: {
      questionId: QUESTION_IDS.ROOM_SELECTION
    }
  });
  const { data: { styleQuizQuestionById: question } } = response;

  return addApolloState(apolloClient,
    {
      props: {
        user,
        question,
        experimentVariations
      },
    });
}, {
  requireAuth: false,
  includeExperimentVariations: true
});
